exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VFTyxKDWQDHYkwYkP5mAu{max-width:600px!important}html[dir] ._2Mcm8FltOi9NAOv5W4r4gT{margin-top:20px}._2zpNTs1ZHCUJo4FQdu6nA8{display:inline-block}", ""]);

// exports
exports.locals = {
	"dialog": "_2VFTyxKDWQDHYkwYkP5mAu",
	"marginTop": "_2Mcm8FltOi9NAOv5W4r4gT",
	"spinner": "_2zpNTs1ZHCUJo4FQdu6nA8"
};